import {
  FormikMultiselectFormFieldWithQuery,
  IFormikMultiselectFormFieldWithQuery,
} from 'components/molecules/MultiselectFormField/FormikMultiselectFormFieldWithQuery';
import { getValueFromCompany } from 'components/molecules/SelectFormField/CompanySelectFormField/CompanySelectFormField';
import { CompaniesDocument, CompaniesQuery } from 'generated/graphql';
import { sortBy } from 'lodash';

interface CompanyFormikMultiselectFormFieldProps
  extends Omit<
    IFormikMultiselectFormFieldWithQuery<CompaniesQuery>,
    'query' | 'queryOptions' | 'getOptionsFromResponse'
  > {
  hasGlobal?: boolean;
}

export function CompanyFormikMultiselectFormField(
  props: CompanyFormikMultiselectFormFieldProps
) {
  const getOptionsFromResponse = (response: CompaniesQuery) => {
    if (response.Companies) {
      return [
        ...(props.hasGlobal ? [{ label: 'Global', value: '-1' }] : []),
        ...sortBy(response.Companies.map(getValueFromCompany), companyOption =>
          companyOption.label.toLocaleLowerCase()
        ),
      ];
    }
    return [];
  };

  return (
    <FormikMultiselectFormFieldWithQuery
      getOptionsFromResponse={getOptionsFromResponse}
      query={CompaniesDocument}
      {...props}
    />
  );
}
